import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

const AUTH_ROUTES = ['/auth/login', '/auth/cliente-login'];

// Adjunta la sesión a cada petición a la API propia. Antes cada pantalla lo hacía a mano y algunas
// (Reportes de Facturación, Clientes por renovar) no lo hacían porque esas rutas eran públicas.
// Si la pantalla ya manda su encabezado Authorization, no se toca.
api.interceptors.request.use(config => {
  try {
    const token = localStorage.getItem('token');
    const url = config.url ?? '';
    const esExterna = /^https?:\/\//i.test(url) && !url.startsWith(config.baseURL ?? '');
    if (token && !esExterna && !config.headers?.has?.('Authorization')) {
      config.headers.set('Authorization', `Bearer ${token}`);
    }
  } catch {
    // sin acceso a localStorage: la petición sigue sin sesión
  }
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (!err.response) {
      err.sinConexion = !navigator.onLine;
      return Promise.reject(err);
    }
    const url = err.config?.url ?? '';
    const esLoginPropio = AUTH_ROUTES.some(r => url.includes(r));
    if (err.response?.status === 401 && !esLoginPropio) {
      ['token', 'role', 'warehouse', 'userId', 'userEmail', 'clieId'].forEach(k =>
        localStorage.removeItem(k)
      );
      window.location.href = '/estado-cuenta?sesion=expirada';
    }
    return Promise.reject(err);
  }
);

export default api;
